import * as React from "react";
import { connect } from "react-redux";
import { Box, Typography } from "@mui/material";
import { AUTH } from "app/utils/constants/endPoint";
import { requestApi } from "app/utils/RestApi";
import { useLocation } from "react-router-dom";

const Footer = (props) => {
  const currentYear = new Date().getFullYear();

  const location = useLocation();

  const [version, setVersion] = React.useState("");

  React.useEffect(() => {
    getVersion();
  }, []);

  async function getVersion() {
    const { data } = await requestApi(AUTH.VERSION);

    if (data.data) {
      setVersion(data.data);
    }
  }
  return (
    <>
      {location.pathname !== "/micrositeLogin" ? (
        <Box
          component="footer"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "1rem",
            backgroundColor: "#f8f9fa",
            borderTop: "1px solid #ddd",
          }}
        >
          <Typography variant="body1" color="text.primary">
            Version {version}
          </Typography>
          <Typography variant="body1" color="text.primary">
            Copyright &copy; {currentYear} Generali Asuransi Indonesia
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            py: 1,
            px: { lg: 6, xs: 4 },
            borderTop: 1,
            borderColor: "divider",
            bgcolor: "background.paper",
            textAlign: "center", // Center text horizontally
            display: "flex",
            flexDirection: "column", // Stack children vertically
            alignItems: "center", // Center content horizontally
          }}
        >
          <Typography variant="body1" color="text.primary">
            Version {version}
          </Typography>
          <Typography variant="body1" color="text.primary">
            Copyright &copy; {currentYear} Generali Asuransi Indonesia
          </Typography>
        </Box>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  authMicrosite: state.authMicrosite,
});

export default connect(mapStateToProps)(Footer);
